<div class="inputs-wrapper">
  <div class="select-option">
    <div class="select-option-info-title">
      <h1>Safra*</h1>
    </div>
    <div class="select-option-info-value">
      <span> Selecione o período da safra </span>
      <mat-form-field class="">
        <mat-label>Safra</mat-label>
        <mat-select [formControl]="form.controls.cropPeriod">
          @for (cropPeriod of cropPeriods; track $index) {
            <mat-option [value]="cropPeriod">{{ cropPeriod }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="select-option">
    <div class="select-option-info-title">
      <h1>Cultura*</h1>
    </div>
    <div class="select-option-info-value">
      <span> Selecione a cultura a ser monitorada </span>
      <mat-form-field class="">
        <mat-label>Cultura</mat-label>
        <mat-select [formControl]="form.controls.cropCulture">
          @for (cropCulture of cropCultures; track $index) {
            <mat-option [value]="cropCulture">{{
              cropCulture.description
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <mat-divider class="divider"></mat-divider>
  <app-upload-shapefile
    [displayConfig]="{
      showTitle: true,
      showDescription: true,
      titlePosition: 'side',
      titleBold: true,
      customTitle: 'Upload de arquivo*',
      customDescription:
        'Selecione o tipo de arquivo e faça o upload das áreas que deseja analisar',
      customDescriptionUpload:
        'Clique ou arraste o arquivo aqui para fazer o upload*',
      showFileTypeSelector: true,
      enabledFileTypes: enabledFileTypes,
      module: 'monitoring',
    }"
    (fileUploaded)="onFileUploaded($event)"
    (originalFileName)="onOriginalFileName($event)"
  ></app-upload-shapefile>
  <mat-divider class="divider"></mat-divider>
  <app-file-params-form
    [fileName]="uploadedFileName ?? undefined"
    [originalFileName]="originalFileName ?? undefined"
    [module]="'monitoring'"
    [isCarRequired]="false"
  >
  </app-file-params-form>
  <mat-divider class="divider"></mat-divider>
  <div class="buttons">
    <button mat-stroked-button (click)="navigateToList()">
      <mat-icon>arrow_back</mat-icon>
      Cancelar
    </button>

    <button mat-flat-button (click)="onSubmit()" [disabled]="isParamsInvalid">
      <mat-icon>save</mat-icon>
      Solicitar
    </button>
  </div>
</div>
